<template>
<div class="view chat-view bg-white clearfix">
  <!-- BEGIN Header  !-->
  <div class="navbar navbar-default">
    <div class="navbar-inner">
      <a href="javascript:;" class="link text-master inline action p-l-10 p-r-10" data-navigate="view" data-view-port="#chat" data-view-animation="push-parrallax">
        <i class="pg-arrow_left"></i>
      </a>
      <div class="view-heading">
        John Smith
        <div class="fs-11 hint-text">Online</div>
      </div>
      <a href="#" class="link text-master inline action p-r-10 pull-right ">
        <i class="pg-more"></i>
      </a>
    </div>
  </div>
  <!-- END Header  !-->
  <!-- BEGIN Conversation  !-->
  <div class="chat-inner" id="my-conversation">
    <!-- BEGIN From Me Message  !-->
    <div class="message clearfix" v-for="message in messages">
      <div class="profile-img-wrapper m-t-5 inline">
        <img class="col-top" width="30" height="30" src="../assets/img/profiles/avatar_small.jpg" alt="" data-src="../assets/img/profiles/avatar_small.jpg" data-src-retina="../assets/img/profiles/avatar_small2x.jpg">
      </div>
      <div v-if="message.user_id === user.id" class="chat-bubble from-me">{{ message.content }}</div>
      <div v-if="message.user_id !== user.id" class="chat-bubble from-them">{{ message.content }}</div>
    </div>        
  </div>
  <!-- BEGIN Conversation  !-->
  <!-- BEGIN Chat Input  !-->
  <div class="b-t b-grey bg-white clearfix p-l-10 p-r-10">
    <div class="row">
      <div class="col-xs-1 p-t-15">
        <a href="#" class="link text-master"><i class="fa fa-plus-circle"></i></a>
      </div>
      <div class="col-xs-8 no-padding">
        <input type="text" class="form-control chat-input" data-chat-input="" data-chat-conversation="#my-conversation" placeholder="Say something">
      </div>
      <div class="col-xs-2 link text-master m-l-10 m-t-15 p-l-10 b-l b-grey col-top">
        <a href="#" class="link text-master"><i class="pg-camera"></i></a>
      </div>
    </div>
  </div>
  <!-- END Chat Input  !-->
</div>
<!-- END Conversation View  !-->
</template>

<script>
  export default {
    name: 'Conversation',
    data: () => ({
      user: {
        id: '1'
      },
      messages: [
        { content: "hello", user_id: '1' },
        { content: "hello too", user_id: '2' },
        { content: "hello three", user_id: '3' },
      ]
    })
  }
</script>


// WEBPACK FOOTER //
// conversation.vue?96ee7f56